import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'wallShade',
      d: 'M-1,-11.5h0.5v0.5h-0.5zM0,-10.5h0.5v0.5h-0.5zM-1,-8.5h0.5v0.5h-0.5zM0.5,-8.5h0.5v0.5h-0.5zM2,-8.5h0.5v0.5h-0.5zM2.5,-8h0.5v0.5h-0.5zM-1,-7.5h0.5v0.5h-0.5zM1.5,-7.5h0.5v0.5h-0.5zM3,-7.5h0.5v0.5h-0.5zM2,-7h1v0.5h-1zM2.5,-6.5h0.5v0.5h-0.5zM-1,-6h2v0.5h-2zM-4,-4h2v0.5h-2zM1.5,-4h2.5v0.5h-2.5zM-3,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h0.5v2.5h-0.5zM-2.5,-2.5h0.5v3h-0.5zM2,-2.5h0.5v3h-0.5zM3,-2.5h0.5v2.5h-0.5zM-1,-2h2v0.5h-2zM-1,-1.5h0.5v2.5h-0.5zM0.5,-1.5h0.5v2.5h-0.5zM-4.5,0h1.5v0.5h-1.5zM3,0h1.5v0.5h-1.5zM-4,0.5h2.5v0.5h-2.5zM1.5,0.5h2.5v0.5h-2.5zM-3.5,1h7.5v0.5h-7.5zM-2.5,1.5h1v0.5h-1z',
    },
    {
      paint: 'roofA',
      d: 'M-1,-8h2v0.5h-2zM-0.5,-7.5h1.5v0.5h-1.5zM-1,-7h2v0.5h-2zM-1,-6.5h2.5v0.5h-2.5zM-1.5,-6h0.5v0.5h-0.5zM1,-6h0.5v0.5h-0.5zM-1.5,-5.5h3v1h-3zM-4,-4.5h8v0.5h-8zM-2,-4h3.5v0.5h-3.5zM-4,-3.5h8v0.5h-8zM-4,-3h1v0.5h-1zM-2.5,-3h5v0.5h-5zM3,-3h1v0.5h-1zM-4,-2.5h0.5v2.5h-0.5zM-2,-2.5h1.5v0.5h-1.5zM0.5,-2.5h1.5v0.5h-1.5zM3.5,-2.5h0.5v2.5h-0.5zM-2,-2h1v2.5h-1zM1,-2h1v2.5h-1zM-1.5,0.5h0.5v0.5h-0.5zM-0.5,0.5h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M0,0.5h0.5v0.5h-0.5z' },
    {
      paint: 'epicMarble',
      d: 'M-0.5,-12.5h1v0.5h-1zM-3,-10.5h0.5v1h-0.5zM2.5,-10.5h0.5v1h-0.5zM-1,-9.5h2v1h-2zM-0.5,-8.5h1v0.5h-1zM-2,-6.5h0.5v0.5h-0.5zM1.5,-6.5h0.5v0.5h-0.5zM-4,-6h2.5v1.5h-2.5zM1.5,-6h2.5v1.5h-2.5zM-3,-2.5h0.5v0.5h-0.5zM-0.5,-2.5h1v0.5h-1zM2.5,-2.5h0.5v0.5h-0.5zM-3,0h0.5v0.5h-0.5zM2.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-3.5,-9.5h1v0.5h-1zM-3.5,-9h1.5v0.5h-1.5zM-4,-8.5h2.5v0.5h-2.5zM-4.5,-8h1v0.5h-1zM-3,-8h2v0.5h-2zM-4.5,-7.5h1.5v0.5h-1.5zM-2.5,-7.5h1.5v0.5h-1.5zM-4.5,-7h0.5v0.5h-0.5zM-3.5,-7h2.5v0.5h-2.5zM-4,-6.5h2v0.5h-2z',
    },
    {
      paint: 'epicMagic',
      d: 'M2.5,-9.5h1v0.5h-1zM2,-9h1.5v0.5h-1.5zM1.5,-8.5h0.5v0.5h-0.5zM2.5,-8.5h1.5v0.5h-1.5zM1,-8h1.5v0.5h-1.5zM3,-8h1.5v0.5h-1.5zM1,-7.5h0.5v0.5h-0.5zM2,-7.5h1v0.5h-1zM3.5,-7.5h1v0.5h-1zM1,-7h1v0.5h-1zM3,-7h1.5v0.5h-1.5zM2,-6.5h0.5v0.5h-0.5zM3,-6.5h1v0.5h-1z',
    },
    {
      paint: 'epicJade',
      d: 'M-0.5,-12h1v0.5h-1zM-0.5,-11.5h1.5v0.5h-1.5zM-1.5,-11h1v0.5h-1zM0,-11h1.5v0.5h-1.5zM-1.5,-10.5h1.5v0.5h-1.5zM0.5,-10.5h1v0.5h-1zM-1,-10h2v0.5h-2z',
    },
    {
      paint: 'epicGold',
      d: 'M-0.5,-11h0.5v0.5h-0.5zM-3.5,-8h0.5v0.5h-0.5zM-3,-7.5h0.5v0.5h-0.5zM-4,-7h0.5v0.5h-0.5z',
    },
    { paint: 'shadow', d: 'M-3,-2h0.5v2h-0.5zM2.5,-2h0.5v2h-0.5zM-0.5,-1.5h1v2h-1z' },
  ],
  pixels: 372,
};
export const sprites: readonly PixelSprite[] = [variant0];
